import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import _ from "lodash";


const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
}));



export default class ProducBillTable extends React.Component {

  render = () => {
    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell  align="center"><b>Codigo</b></TableCell>
            <TableCell  align="center"><b>Producto</b></TableCell>
            <TableCell align="right"><b>Precio x unidad</b></TableCell>
            <TableCell align="right"><b>Cantidad</b></TableCell>
            <TableCell align="right"><b>Subtotal</b></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.props.products.map((row) => (
            <TableRow key={row.id}>
              <TableCell align="center">{row.id}</TableCell>
              <TableCell align="center">{row.desc}</TableCell>
              <TableCell align="right">{row.price}</TableCell>
              <TableCell align="right">{row.qty}</TableCell>
              <TableCell align="right">{row.subtotal}</TableCell>
            </TableRow>
          ))}
         
          {this.props.creditNoteDiscount&&
          <TableRow>
          <TableCell colSpan={4}><b>Descuento Nota de credito</b></TableCell>
          <TableCell align="right"><b>- ${this.props.creditNoteDiscount}</b></TableCell>
        </TableRow>
          }
           {this.props.showInterest&&
            <TableRow>
            <TableCell colSpan={4}><b>Intereses Tarjeta {this.props.cardDesc}</b></TableCell>
            <TableCell align="right"><b>{this.props.interest}%</b></TableCell>
          </TableRow>  
          }

          <TableRow>
            <TableCell colSpan={4}><b>Total</b></TableCell>
            <TableCell align="right"><b>${this.props.total}</b></TableCell>
          </TableRow>
        </TableBody>

      </Table>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Billing/ProductBillTable.js